import { isServerSide } from '@docs/common'
import { useMemo } from 'react'
import ContentLoader, { IContentLoaderProps } from 'react-content-loader'

const ResponsiveArticle = (props: IContentLoaderProps) => {
  const viewH = useMemo(() => {
    return isServerSide() ? 0 : window.innerHeight - 80
  }, [])
  const viewW = useMemo(() => {
    return isServerSide() ? 0 : window.innerWidth - 40
  }, [])

  if (isServerSide()) {
    return null
  }

  return (
    <ContentLoader viewBox={`0 0 ${viewW} ${viewH}`} height={viewH} width={'100%'} {...props}>
      <rect x="0" y="20" rx="5" ry="5" width="100%" height="200" />
      <rect x="0" y="265" rx="5" ry="5" width="100%" height="10" />
      <rect x="0" y="285" rx="5" ry="5" width="100%" height="10" />
      <rect x="0" y="305" rx="5" ry="5" width="100%" height="10" />
      <rect x="0" y="335" rx="5" ry="5" width="100%" height="10" />
      <rect x="0" y="355" rx="5" ry="5" width="100%" height="10" />
      <rect x="0" y="375" rx="5" ry="5" width="100%" height="10" />
      <rect x="0" y="395" rx="5" ry="5" width="100%" height="8" />
      <rect x="0" y="415" rx="5" ry="5" width="100%" height="8" />
      <rect x="0" y="445" rx="5" ry="5" width="100%" height="8" />
      <rect x="0" y="465" rx="5" ry="5" width="100%" height="8" />
      <rect x="0" y="485" rx="5" ry="5" width="100%" height="8" />
      <rect x="0" y="505" rx="5" ry="5" width="100%" height="8" />
      <rect x="0" y="525" rx="5" ry="5" width="100%" height="8" />
    </ContentLoader>
  )
}

ResponsiveArticle.metadata = {
  name: 'Ashiru Olawale', // My name
  github: 'walebant', // Github username
  description: 'A responsive article loader that fits every screen 🎉', // Little tagline
  filename: 'ResponsiveArticle', // filename of your loader
}

export default ResponsiveArticle
